<template>
<div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
            <wcselect :option="{placeholder:'配送类型',ischange:true,width:'170px',clearable:true,filterable:true}" 
                :value="param.type"
                :list="typelist"
                @finish="(val)=> {
                    param.type=val.value;
                    param.ischange=true;
                    GetList();
                }"
            />
        </el-form-item>
        <el-form-item>
        <wcinput :option="{placeholder:'请输入续费名称',clearable:true,ischange:true,width:'250px',isinput:true,iskeydown:true,clearable:true}" 
            :value="param.key"
            @finish="(val)=> {
                if(val.type=='input') {param.key=val.value;param.ischange=true}
                if(val.type=='change') {param.key=val.value;param.ischange=true}
                if(val.type=='keydown') GetList();
            }"
        />
        </el-form-item>
        <el-form-item>
        <wcbutton :option="{title:'搜索'}" @finish="GetList"/>
        </el-form-item>
        <el-form-item>
        <wcbutton :option="{title:'添加运费设置'}" @finish="$parent.JUMPVIEW({name:'EsAddShipping'})"/>
        </el-form-item>
        <el-form-item>
        <wcbutton :option="{title:'查看外卖员'}" @finish="$parent.JUMPVIEW({name:'EsMembers',param:{key:'',iscompany:'',is_robot:3,ischange:true}})"/>
        </el-form-item>
    </el-form>
</div>


<div class="TTL-table top20" :ref="objloading">
    <el-table :data="list" stripe="true" empty-text="" >
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column prop="name" label="名称" align="center"/>
        <el-table-column label="类型" align="center">
            <template #default="scope">
                <span v-if="scope.row.type==1">距离</span>
                <span v-if="scope.row.type==2">重量</span>
                <span v-if="scope.row.type==3">体积</span>
            </template>
        </el-table-column>
        <el-table-column label="起送（距离/重量/体积）" align="center">
            <template #default="scope">
                <span v-if="scope.row.type==1">{{scope.row.lowvalue+' km'}}</span>
                <span v-if="scope.row.type==2">{{scope.row.lowvalue+' kg'}}</span>
                <span v-if="scope.row.type==3">{{scope.row.lowvalue+' m³'}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="price" label="起送金额" align="center"/>
        <el-table-column label="每增加单位（距离/重量/体积）" align="center">
            <template #default="scope">
                <span v-if="scope.row.type==1">{{scope.row.unitvalue+' km'}}</span>
                <span v-if="scope.row.type==2">{{scope.row.unitvalue+' kg'}}</span>
                <span v-if="scope.row.type==3">{{scope.row.unitvalue+' m³'}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="unitprice" label="增加单位金额" align="center"/>
        <el-table-column prop="inputtime" label="添加时间" align="center"/>
        <el-table-column label="操作" align="center" min-width="150">
            <template #default="scope">
            <div class="TTL-btn-info">
                <wcbutton :option="{title:'编辑'}" @finish="$parent.JUMPVIEW({name:'EsEditShipping',param:{ids:scope.row.id}})" class="left10"/>
                <wcbutton :option="{title:'删除',type:'del'}" @finish="delshipping(scope.row.id)" class="left10"/>
            </div>
            </template>
        </el-table-column>
    </el-table>
</div>


<div class="TTL-page-box top20">
    <div class="TTL-page-box-in">
        <div class="TTL-page TTL-page-right">
            <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                @finish="(val)=> {
                    param.p=val.p;
                    param.rollpage=val.rollpage;
                    GetList();
                }"
            />
        </div>
    </div>
</div>



</template>

<script>
import INTERFACE_MODEL_SHIPPING from '@/Interface/Es/shipping';
export default {

    components:{
        
    },

    data() {
        return {
            objloading:'shipping',
            param: {
                key:'',
                type:'',
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },
            list:[],
            typelist:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除数据'},
                {id:2,name:'批量修改数据'},
            ],

        }
    },

    mounted() {

        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetShippingType(isfresh);
            this.GetList();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                this.GetList();
            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }else {
                this.GetList();
            }
        },


        /** 列表数据搜索 **/
        GetList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            var obj=this.$refs[this.objloading];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_SHIPPING.GET_SHIPPING_LIST(this.param).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
            });
        },

        
        /** 删除设置 **/
        delshipping(id) {
            INTERFACE_MODEL_SHIPPING.DEL_SHIPPING({ids:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.param.ischange=true;
                 this.GetList();
            });
        },


        /** 获取运费类型 **/
        GetShippingType(isfresh) {
            this.$method.GET_SHIPPING_TYPE(isfresh).then((res) => {this.typelist=res;console.log(res)});
        },


    },
}
</script>
<style scoped>
::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
.TTL-btn-info {display:inline-flex;}
.ttl-frozen {display: inline-flex;justify-content: center;align-items: center;width:100% !important;}
.ttl-frozen .el-image{display: inline-block;width:25px;height:25px;margin-right:5px;}
.ttl-finiss {display:inline-block;width:100%;text-align:center;font-size:13px;color:#666666;letter-spacing:1px;color:#666eeb}
.answer-name {font-style: normal;color:#666eeb;}
.goods-commont {display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;width:100%;}
.goods-commont-box {display:inline-flex;width:200px;padding:15px 0;font-size:0;}
.goods-commont-box .el-image {width:50px;height:50px;border-radius: 50%;display: inline-block;}
.goods-commont-content {display: inline-block;width:calc(100% - 50px - 15px);min-height: 50px;font-size:0;}
.goods-commont-name {display: inline-flex;align-items: center;width:100%;font-size:12px;line-height:18px;position:relative;}
.goods-commont-time {position:absolute;right:0;font-size:12px;}
.goods-commont-name i {font-style:normal;color:#999999}
.content {display: inline-block;margin-top:0;}
.membername {font-size:13px;color:#666eeb;}
.TTL-info {display: inline-flex;justify-content: center;}
::v-deep(.TTL-info .TTL-input .el-input__inner) {text-align: center;}
.TTL-renewname {color:#666eeb;cursor: pointer;}
</style>